/**
 * @desc Bikepark trails state actions, mutations and default state values
 *
 * @author Mike Hamilton <mike@mikehamilton.ca>
 */

export default {
  state: {
    name: "trails",
    layerTitle: "Bike Trails",
    geojson: [],
    visibility: {
      mapView: false,
      listView: false,
      singleView: false,
      singleId: 0
    },
    loading: false,
    hasListView: true
    // legend: [
    //   {
    //     name: "beginner",
    //     icon: "greenIcon",
    //   },
    //   {
    //     name: "intermediate",
    //     icon: "blueIcon",
    //   },
    //   ,
    //   {
    //     name: "advanced",
    //     icon: "blackIcon",
    //   },
    // ],
  }
};
